import toDate from '../to-date';

export const eachDayOfInterval = (startDate: Date | number, endDate: Date | number) => {
  const formattedStartDate = toDate(startDate);
  const formattedEndDate = toDate(endDate);

  const currentDate = formattedStartDate;
  currentDate.setHours(0, 0, 0, 0);

  const dates = [];

  while (formattedStartDate.getTime() <= formattedEndDate.getTime()) {
    dates.push(toDate(currentDate));

    currentDate.setDate(currentDate.getDate() + 1);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
};

export default eachDayOfInterval;
